<i18n src="@/locales/components/MissionDayTranslate.json"></i18n>

<template>
	<div class="data-list-container missions-day-table pt-5">
		<audio id="missionAudio" muted @ended="handlePlayEnd">
			<source id="audioSource" type="audio/mpeg" />
			Your browser does not support the audio element.
		</audio>
		<div class="fixed right-0 mr-2 " style="z-index: 999; top: calc(100% - 100px)">
			<vx-tooltip v-if="!isFullScreens" :text="$t('FullScreen')" position="left">
				<vs-button class="relative" @click="openFullscreen" radius color="primary" type="flat" icon-pack="nucleo" icon="nucleo-scale-up"></vs-button>
			</vx-tooltip>
			<vx-tooltip v-else :text="$t('ExitFullScreen')" position="left">
				<router-link class="" exact :to="$constant.PAGES_PATH.PAGE_CBS_TODO_PATH">
					<vs-button class="relative" radius color="primary" type="flat" icon-pack="nucleo" icon="nucleo-scale-down"></vs-button>
				</router-link>
			</vx-tooltip>
		</div>

		<div class="tip-speaker flex mr-1">
			<p v-if="muted" class="tooltiptext">{{ $t("UnMutedSpeaker") }}</p>
			<vs-button class="ml-3" @click="unMuted" radius color="primary" type="border" icon-pack="nucleo" :icon="muted ? 'nucleo-megaphone' : 'nucleo-megaphone-2'" size="large"> </vs-button>
		</div>
		<vs-table ref="table-mission" id="table-data-missions-day" :sst="true" class="vs-con-loading__container stack-table" :noDataText="$t('Notify.NoDataAvailable')" :data="todoList">
			<template slot="thead">
				<vs-th class="no-sorter">
					<span class="uppercase font-medium"> {{ $t("Relations") }} </span>
				</vs-th>
				<vs-th class="no-sorter">
					<span class="uppercase font-medium"> {{ $t("Task") }}</span>
				</vs-th>
				<vs-th class="no-sorter">
					<span class="uppercase font-medium"> {{ $t("Dueday") }}</span>
				</vs-th>
				<vs-th class="no-sorter">
					<span class="uppercase font-medium"> {{ $t("Part") }}</span>
				</vs-th>
				<vs-th class="no-sorter">
					<span class="uppercase font-medium"> {{ $t("Status") }}</span>
				</vs-th>
			</template>

			<template slot-scope="{ data }">
				<tbody>
					<vs-tr
						:class="['cursor-default', { 'new-mission': newMission && indextr === $store.state.moduleMissionday.indexUpdate, 'bg-odd': indextr % 2 === 0 }]"
						:data="tr"
						:key="indextr"
						v-for="(tr, indextr) in data"
					>
						<vs-td :data-header="$t('Device')">
							<p v-for="(name, idx) in tr.relationDevices.device_name" :key="`device_name${idx}`" class="todo-item-device font-bold uppercase">{{ name }}</p>
						</vs-td>

						<vs-td :data-header="$t('Task')">
							<p class="employee-name font-bold uppercase">{{ tr.name }}</p>
						</vs-td>

						<vs-td :data-header="$t('Dueday')">
							<p class="employee-dob font-bold uppercase">{{ tr.properties && tr.properties !== "" ? momentFromNow(JSON.parse(tr.properties).deadline) : "" }}</p>
						</vs-td>

						<vs-td :data-header="$t('Part')">
							<p v-for="(assinee, idx) in tr.assignees" :key="`assinee${idx}`" class="employee-email font-bold break-all sm:max-w-xs uppercase">{{ assinee.name }}</p>
						</vs-td>

						<vs-td :data-header="$t('Status')">
							<p
								:class="[
									{ 'text-solid-red': JSON.parse(tr.properties).is_done === false, 'text-solid-green-1': JSON.parse(tr.properties).is_done === true },
									'font-bold todo-item-status font-bold sm:truncate uppercase'
								]"
							>
								{{ $t(`${$options.filters.isDoneStatus(JSON.parse(tr.properties).is_done)}`) }}
							</p>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
		<CbsPagination class="mt-3" :total="totalPages" v-model="currentx" />
	</div>
</template>

<script>
import moduleMissionday from "@/store/mission-day/moduleMissionday";
import moment from "moment";
import { mapGetters } from "vuex";
import * as _ from "lodash";
let start = new Date();

start.setHours(0, 0, 0, 0);

let end = new Date();
end.setHours(23, 59, 59, 0);
const startToday = start.toISOString();
const endToday = end.toISOString();

const today = new Date();
const startTomorrow = new Date(today);
// startTomorrow.setUTCDate(startTomorrow.getUTCDate() + 1);
startTomorrow.setHours(0, 0, 0, 0);
const _startTomorrow = startTomorrow.toISOString();

const endTomorrow = new Date(today);
// endTomorrow.setUTCDate(endTomorrow.getUTCDate() + 1);
endTomorrow.setHours(23, 59, 59, 0);
const _endTomorrow = endTomorrow.toISOString();

export default {
	data() {
		return {
			activeAudio: "",
			playing: false,
			currentx: 1,
			testIndex: 0,
			newMission: false,
			muted: true,
			filters: {
				from_start_date: startToday,
				to_start_date: endToday,
				from_deadline: _startTomorrow,
				to_deadline: _endTomorrow
			},
			isFullScreens: false
		};
	},
	methods: {
		async openFullscreen() {
			document.getElementsByTagName("BODY")[0].setAttribute("id", "main-fullscreen");
			const elem = document.getElementById("main-fullscreen");
			if (elem.requestFullscreen) {
				await elem.requestFullscreen();
			} else if (elem.mozRequestFullScreen) {
				/* Firefox */
				await elem.mozRequestFullScreen();
			} else if (elem.webkitRequestFullscreen) {
				/* Chrome, Safari and Opera */
				await elem.webkitRequestFullscreen();
			} else if (elem.msRequestFullscreen) {
				/* IE/Edge */
				await elem.msRequestFullscreen();
			}
			this.isFullScreens = true;
		},
		closeFullscreen() {
			if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
				return;
			}
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.mozCancelFullScreen) {
				/* Firefox */
				document.mozCancelFullScreen();
			} else if (document.webkitExitFullscreen) {
				/* Chrome, Safari and Opera */
				document.webkitExitFullscreen();
			} else if (document.msExitFullscreen) {
				/* IE/Edge */
				document.msExitFullscreen();
			}
			this.isFullScreens = false;
		},
		layoutType(val) {
			this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", val);
		},
		unListnerSocket() {},
		handleNewMission(item) {
			let audio = null;
			if (item.speech) {
				audio = { todoId: item.todo_list.id, path: item.speech.path };
			}
			const payload = {
				mission: { ...item.todo_list, relations: item.relations, employees: item.employees },
				audio: audio
			};

			this.$store.dispatch("moduleMissionday/handleNewMissionFromSocket", payload);
			this.playAudio();
		},
		playAudio() {
			const audio = document.getElementById("missionAudio");
			if (!this.playing && this.$store.state.moduleMissionday.audios && this.$store.state.moduleMissionday.audios.length > 0 && !this.muted) {
				this.playing = true;
				this.newMission = true;
				this.activeAudio = this.$store.state.moduleMissionday.audios[0];
				// Check xem đã playaudio cho todolist này chưa
				const findInPlayedAudios = _.find(this.$store.state.moduleMissionday.playedAudios, { todoId: this.activeAudio.todoId });
				if (findInPlayedAudios) {
					// Đã phát âm thanh 1 lần của todolist item này rồi
					this.$store.dispatch("moduleMissionday/deletePlayedAudio");
					this.playing = false;
					this.newMission = false;
				} else {
					let source = document.getElementById("audioSource");
					source.src = this.activeAudio.path;
					audio.load(); //call this to just preload the audio without playing
					audio.play();
				}
			}
		},
		handlePlayEnd() {
			this.playing = false;
			this.$store.dispatch("moduleMissionday/deletePlayedAudio", this.activeAudio.todoId);
			this.playAudio();
			this.newMission = false;
		},
		loadMoreMission() {
			this.$vs.loading({
				container: "#table-data-missions-day",
				scale: 0.6
			});

			this.$store
				.dispatch("moduleMissionday/fetchMissionday", { limit: this.$store.state.moduleMissionday.limitPerPage, page: this.currentx, ...this.filters })
				.then(() => {
					let listA = [];
					this.$store.state.moduleMissionday.missions.map(mission => {
						if (mission.speech) {
							listA.push({ todoId: mission.id, path: mission.speech.path });
						}
					});
					if (listA.length > 0) {
						this.$store.dispatch("moduleMissionday/resetPlayList", { audios: listA, playedAudios: [] });
						this.playAudio();
					}
					this.$vs.loading.close("#table-data-missions-day > .con-vs-loading");
				})
				.catch(() => {
					this.$vs.loading.close("#table-data-missions-day > .con-vs-loading");
				});
		},
		handleEsc() {
			document.addEventListener("fullscreenchange", this.handleScreenChange, false);
			// document.addEventListener("mozfullscreenchange", this.handleScreenChange, false);
			// document.addEventListener("webkitfullscreenchange", this.handleScreenChange, false);
			// document.addEventListener("msfullscreenchange", this.handleScreenChange, false);
		},
		handleScreenChange() {
			if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
				// Run code on exit
				this.$router.go(-1);
			}
		},
		momentFromNow(date) {
			let locale = "vi";
			if (this.userSettings && this.userSettings.locale) {
				locale = this.userSettings.locale === "vn" ? "vi" : "en";
			}
			moment.locale(locale);
			return moment(date).fromNow();
		},
		unMuted() {
			const audio = document.getElementById("missionAudio");
			this.muted = !this.muted;
			audio.muted = this.muted;
			if (!this.muted) {
				this.playAudio();
			} else {
				this.playing = false;
				audio.pause();
			}
		},
		replayAudios() {
			// this.$store.dispatch("moduleMissionday/resetPlayListEveryAnHour");
			// this.playAudio();
			this.loadMoreMission();
		}
	},
	created() {
		this.layoutType("horizontal");
		this.$store.registerModule("moduleMissionday", moduleMissionday);
		this.handleEsc();
		this.$store.commit("TOGGLE_NAVBAR", false);
		let timeRepeat = 3600000;
		if (this.$store.state.AppActiveUser.preferences && this.$store.state.AppActiveUser.preferences.length > 0) {
			const { todo_speech_delay } = JSON.parse(this.$store.state.AppActiveUser.preferences);
			if (todo_speech_delay) {
				timeRepeat = 60000 * todo_speech_delay;
			}
		}
		this.intervalReplayAudios = setInterval(() => {
			this.replayAudios();
		}, timeRepeat);
	},
	mounted() {
		this.loadMoreMission();
		this.sockets.subscribe("sensors", data => {
			const item = data.data;
			switch (item.event) {
				case this.$constant.SOCKET_EVENT.NEW_MISSION_DAY:
				case this.$constant.SOCKET_EVENT.UPDATED_MISSION_DAY:
				case this.$constant.SOCKET_EVENT.DONE_MISSION_DAY:
					this.handleNewMission(item);
					break;
				case this.$constant.SOCKET_EVENT.DELETED_MISSION_DAY:
					// delete
					this.$store.dispatch("moduleMissionday/deleteMission", item);
					break;
			}
		});
		setTimeout(() => {
			this.openFullscreen();
		}, 1000);
		this.isFullScreens = document.fullscreen;
	},
	beforeDestroy() {
		clearInterval(this.intervalReplayAudios);
		this.closeFullscreen();
		this.layoutType("vertical");
		this.unListnerSocket();
		this.$store.commit("TOGGLE_NAVBAR", true);
		this.$store.dispatch("moduleMissionday/resetPlayList", { audios: [], playedAudios: [] });
		this.$store.unregisterModule("moduleMissionday");
		this.sockets.unsubscribe("sensors");
		document.removeEventListener("fullscreenchange", this.handleScreenChange, false);
	},
	computed: {
		totalPages() {
			return Math.ceil(this.$store.state.moduleMissionday.total / this.$store.state.moduleMissionday.limitPerPage);
		},
		...mapGetters({
			getParsedMissionList: "moduleMissionday/getParsedMissionList"
		}),
		todoList() {
			return this.getParsedMissionList || [];
		}
	},
	watch: {
		currentx() {
			this.loadMoreMission();
		}
	}
};
</script>

<style lang="scss" scoped>
.new-mission {
	background-color: #fffbf0;
}
.tip-speaker {
	position: fixed;
	right: 1%;
	bottom: 2%;
	z-index: 999;
	.tooltiptext {
		background-color: black;
		color: #fff;
		text-align: center;
		padding: 5px;
		border-radius: 6px;
		align-self: center;
		/* Position the tooltip text - see examples below! */
		z-index: 1;
		position: relative;
		&::after {
			content: " ";
			position: absolute;
			top: 50%;
			left: 100%;
			margin-top: -5px;
			border-width: 5px;
			border-style: solid;
			border-color: transparent transparent transparent black;
		}
	}
}
.missions-day-table {
	.vs-con-table {
		.vs-table {
			tr {
				box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.13) !important;
				border-radius: 8px;
				p,
				th {
					font-size: 1rem;
					@media only screen and (min-width: 1290px) {
						font-size: 1.6rem;
					}
				}
			}
		}
	}
}
</style>
